export const listOfValidUploadTypes = ".jpg,.jpeg,.png,.gif,.svg,.pdf,.doc,.docx,.ppt,.pptx,.pps,.ppsx,.odt,.xls,.xlsx,.zip,.csv,.3gp,.mp4";
export const supportUploadTypes = `${listOfValidUploadTypes},.har,.txt,.json`;

export default listOfValidUploadTypes;
